import { useContext, useState } from "react";
import CelesFloatingInputState from "../components/leasing.c.celesfloatinginputstate";
import Content from "../components/leasing.c.content";
import { setDate } from "date-fns";
import { DatePicker, Space } from "antd";
import moment from "moment";
import thTH from "antd/lib/locale-provider/th_TH";
import "moment/locale/th";
import classNames from "classnames";
import { ReversePaymentContext } from "../context/leasing.ctx.reversePayment";

moment.locale("th");

const FootageUserData = ({ loan, date, onClickSubmit, onChangeDate }) => {
  const [open, setOpen] = useState(true);
  const {
    openReverse,
    setOpenReverse,
    currentEvidenceIndex,
    setCurrentEvidenceIndex,
    evidence,
    setEvidence,
  } = useContext(ReversePaymentContext);

  return (
    <div className="bg-white mb-1 px-1">
      <div className="flex flex-row justify-between p-2">
        <div className="font-bold text-lg text-coolGray-700">ข้อมูลลูกค้า</div>
        {open ? (
          <svg
            onClick={() => setOpen(false)}
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M5 15l7-7 7 7"
            />
          </svg>
        ) : (
          <svg
            onClick={() => setOpen(true)}
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        )}
      </div>
      <div
        className={
          "grid grid-cols-6  p-3 pt-0 bg-white " + (open ? "" : "hidden")
        }
      >
        <Content
          label="ชื่อ"
          value={`${loan?.article || ""} ${loan?.fullname}`}
        />
        <Content label="บัตรประชาชน" value={loan?.citizenid} />
        <Content
          label="ที่อยู่"
          value={`${loan?.addressCode || ""} ${loan?.addressDesc || ""} ${
            loan?.address
          }`}
        />
        <Content label="เลขบัญชี" value={loan?.bankNo} />
        <DatePicker
          allowClear={false}
          format={"DD-MM-YYYY"}
          // defaultValue={moment(date)}
          value={moment(date)}
          onChange={onChangeDate}
        />
        {/* <CelesFloatingInputState
          label="วันที่ปัจจุบัน"
          type="date"
          value={date}
          onChange={onChangeDate}
        /> */}
        <button
          onClick={openReverse ? () => {} : onClickSubmit}
          className={classNames(" px-2 py-3 text-white ml-2 rounded-sm", {
            "cursor-not-allowed bg-gray-400": openReverse,
            "bg-green-500": !openReverse,
          })}
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default FootageUserData;
